var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelVentSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.88 10.44L11.29 4.28001L9.54001 3.26001V5.29001V18.16V18.83L10.12 19.16L20.71 25.32L22.46 26.34V24.31V11.45V10.77L21.88 10.44Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 11.45L10.7 5.29001V18.16L21.3 24.31V11.45Z",
    fill: "#DDDDDF",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.28 12.7L19.29 13.03L12.74 9.27L12.72 9",
    fill: "#A6A6A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.28 12.7L19.29 13.03L12.74 9.27L12.72 9",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.28 15.26L19.29 15.58L12.74 11.83L12.72 11.56",
    fill: "#A6A6A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.28 15.26L19.29 15.58L12.74 11.83L12.72 11.56",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.28 17.82L19.29 18.14L12.74 14.39L12.72 14.12",
    fill: "#A6A6A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.28 17.82L19.29 18.14L12.74 14.39L12.72 14.12",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.28 20.38L19.29 20.7L12.74 16.95L12.72 16.68",
    fill: "#A6A6A7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.28 20.38L19.29 20.7L12.74 16.95L12.72 16.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelVentSystem);
export default __webpack_public_path__ + "static/media/SelVentSystem.192b4bad77a913058cf8273afe5af95b.svg";
export { ForwardRef as ReactComponent };